export default {
    title: state => {
        return state.title;
    },
    sections: state => {
        return state.sections;
    },
    sectionsForCurrentUser:state=>{
        return state.sectionsForCurrentUser;
    },
    section: state => {
        return state.section;
    },
    sectionToEdit: state => {
        return state.sectionToEdit;
    },
    total: state => {
        return state.total;
    }
}
